module.exports = __webpack_public_path__ + "static/img/bg_activity2.6ae9ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/bg_activity2.png
// module id = edSY
// module chunks = 1